import './scss/index.scss'

import Vue from 'vue'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'

import Notifications from 'vue-notification'
import VeeValidate, { Validator } from 'vee-validate'
import VueAnalytics from 'vue-analytics'

import generalLayout from './layouts/general.vue'
import store from './store'
import router from './router'

Vue.use(VueI18n)
Vue.use(VueRouter)
Vue.use(VeeValidate)
Vue.use(Notifications)

Vue.use(VueAnalytics, {
  id: process.env.GA_TRACKING_ID,
  checkDuplicatedScript: true
})

window.Validator = Validator
window.allowedLocale = ['en', 'fr']
window.loadedLocale = []
window.i18n = new VueI18n({
  locale: window.allowedLocale[0]
})
const i18n = window.i18n

// eslint-disable-next-line
const app = new Vue({
  components: { generalLayout },
  render: h => h('general-layout'),
  el: '#app',
  store,
  router,
  i18n,
  mounted () {
    store.dispatch('auth/startRenewalTimer')
  }
})
